/* Get Karier — kemudahan panel nav mobile (redesign PR-2).

   Buka-tutup panelnya sudah ditangani <details> secara native, jadi file ini
   BUKAN syarat panel berfungsi. Isinya cuma dua hal yang tidak dipunyai
   <details> sendiri:

   1. Tutup waktu diklik di luar panel.
   2. Tutup waktu Escape ditekan, lalu kembalikan fokus ke hamburger.

   Ditulis tanpa dependensi dan aman dipanggil berkali-kali. */
(function () {
  'use strict';

  function tutupSemua(kecuali) {
    var semua = document.querySelectorAll('details[data-gk-nav][open]');
    for (var i = 0; i < semua.length; i++) {
      if (semua[i] !== kecuali) semua[i].removeAttribute('open');
    }
  }

  // 26 Sep 2026: panel jadi laci setinggi layar. Latar gelap dan tombol X
  // (data-gk-nav-tutup) ada DI DALAM <details>, jadi klik di sana tidak
  // tertangkap aturan "klik di luar" di bawah dan perlu ditutup sendiri.
  document.addEventListener('click', function (e) {
    var tutup = e.target.closest ? e.target.closest('[data-gk-nav-tutup]') : null;
    if (tutup) {
      tutupSemua(null);
      return;
    }
    var di = e.target.closest ? e.target.closest('details[data-gk-nav]') : null;
    tutupSemua(di);
  });

  // Kunci gulir halaman selama laci terbuka, seperti drawer portal. Event
  // toggle tidak menggelembung, jadi dipasang di fase capture.
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('details[data-gk-nav]')) return;
    document.documentElement.style.overflow = e.target.open ? 'hidden' : '';
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var terbuka = document.querySelector('details[data-gk-nav][open]');
    if (!terbuka) return;
    terbuka.removeAttribute('open');
    var ringkas = terbuka.querySelector('summary');
    if (ringkas) ringkas.focus();
  });
})();
